var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tab-button",class:{
        active: _vm.isActive,
        'tab-button--regular': !_vm.isDayTab,
        'tab-button--day': _vm.isDayTab,
        'pointer-events-none': _vm.$store.state.globals.isGenericErrorMessageVisible,
    }},[_c('span',{staticClass:"tab-button__inner leading-none"},[(_vm.desktopLabelPrefix)?_c('span',{staticClass:"hidden sm:inline"},[_vm._v(" "+_vm._s(_vm.desktopLabelPrefix)+" ")]):_vm._e(),_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }